module.exports = __webpack_public_path__ + "static/media/FLINDERS-CIRCLE.b5c27ab6.gif";